import styled from 'styled-components';
import { Card } from '@perch-labs/shrike';
import { Container } from 'styles';

export const ErrorTypeNotificationCard = styled(Card)<StyleProps>`
  border-left: 8px solid ${props => props.theme.colors.content.error} !important;
  border-right: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-top: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-bottom: 1px solid rgba(11, 31, 28, 0.16) !important;
`;

export const WarningTypeNotificationCard = styled(Card)<StyleProps>`
  border-left: 8px solid ${props => props.theme.colors.content.warningBright};
  border-right: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-top: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-bottom: 1px solid rgba(11, 31, 28, 0.16) !important;
`;

export const PrimaryNotificationCard = styled(Card)<StyleProps>`
  border-left: 8px solid rgba(11, 31, 28, 0.16) !important;
  border-right: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-top: 1px solid rgba(11, 31, 28, 0.16) !important;
  border-bottom: 1px solid rgba(11, 31, 28, 0.16) !important;
`;

export const StyledContainer = styled(Container)`
  position: relative;
`;
